// A new, empty PDF: `pages` blank pages of the given sizes (points). Small enough to write by hand; everything else (text, images, shapes,
// form fields, more pages) is added with the Reader's edit tools and written by saveWithAnnotations.

export const PAGE_SIZES: Array<{ id: string; label: string; w: number; h: number }> = [
    { id: "letter", label: "Letter (8.5 × 11 in)", w: 612, h: 792 },
    { id: "a4", label: "A4 (210 × 297 mm)", w: 595.28, h: 841.89 },
    { id: "legal", label: "Legal (8.5 × 14 in)", w: 612, h: 1008 },
    { id: "tabloid", label: "Tabloid (11 × 17 in)", w: 792, h: 1224 },
    { id: "a3", label: "A3 (297 × 420 mm)", w: 841.89, h: 1190.55 },
    { id: "a5", label: "A5 (148 × 210 mm)", w: 419.53, h: 595.28 }
];

export function createBlankPdf(pages: Array<[number, number]>, title = "Untitled"): Uint8Array {
    const n = Math.max(1, pages.length);
    const parts: string[] = [];
    const offsets: number[] = [];
    let len = 0;
    const push = (s: string) => { parts.push(s); len += s.length; };
    const obj = (num: number, body: string) => { offsets[num] = len; push(`${num} 0 obj\n${body}\nendobj\n`); };
    push("%PDF-1.7\n%\xe2\xe3\xcf\xd3\n");
    // 1 catalog, 2 page tree, 3 info, then one page + one empty content stream per page
    obj(1, "<< /Type /Catalog /Pages 2 0 R >>");
    obj(2, `<< /Type /Pages /Count ${n} /Kids [${Array.from({ length: n }, (_, i) => `${4 + i * 2} 0 R`).join(" ")}] >>`);
    const t = title.replace(/[()\\]/g, "");
    obj(3, `<< /Title (${t}) /Producer (Fowlguard PDF) >>`);
    for (let i = 0; i < n; i++) {
        const [w, h] = pages[i] ?? pages[0] ?? [612, 792];
        obj(4 + i * 2, `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${w} ${h}] /Resources << >> /Contents ${5 + i * 2} 0 R >>`);
        obj(5 + i * 2, "<< /Length 0 >>\nstream\n\nendstream");
    }
    const size = 4 + n * 2;
    const xref = len;
    let x = `xref\n0 ${size}\n0000000000 65535 f \n`;
    for (let i = 1; i < size; i++) x += `${String(offsets[i]).padStart(10, "0")} 00000 n \n`;
    push(x + `trailer\n<< /Size ${size} /Root 1 0 R /Info 3 0 R >>\nstartxref\n${xref}\n%%EOF\n`);
    const out = new Uint8Array(len);
    let p = 0;
    for (const s of parts) for (let i = 0; i < s.length; i++) out[p++] = s.charCodeAt(i) & 255;
    return out;
}
